import script from "./RegionStatsItem.vue?vue&type=script&setup=true&lang=js"
export * from "./RegionStatsItem.vue?vue&type=script&setup=true&lang=js"

import "./RegionStatsItem.vue?vue&type=style&index=0&id=44ed6472&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44ed6472"]])

export default __exports__